import { useCallback } from 'react';
import { routes } from 'routes/routes';

export const usePathToProgramDetail = () => useCallback((id: string) => routes.program.timeline(id), []);
